/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import CodeSelector from 'material/embeds/codeselector/codeselector';



/* ========== ~~~~~~~~~~ EMBED : CODE SELECTOR : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => ({
    bodyCode: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.bodyCode,
    headerCode: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.headerCode
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(CodeSelector);
